import {
    createEntityAdapter,
    EntityAdapter,
    EntityState
} from '@ngrx/entity';
import { Persona } from '../../models';
import { PersonaActionTypes, PersonaActions } from './persona.actions';

export const personasFeatureKey = 'personas';

export interface State extends EntityState<Persona> {
    loading: boolean;
    selectedPersona: Persona;
    skipSelection: boolean;
}

export const adapter: EntityAdapter<Persona> = createEntityAdapter<Persona>(
    {
        selectId: (entity: Persona) => entity['organisationGroupId'],
        sortComparer: false,
    });

export const initialState: State = adapter.getInitialState(
    {
        loading: false,
        selectedPersona: null,
        skipSelection: false
    });

export function reducer(
    state = initialState,
    action: PersonaActions): State {
    let newState;

    switch (action.type) {
    case PersonaActionTypes.LOAD:
        return { ...state };

    case PersonaActionTypes.LOAD_SUCCESS:
        newState = { ...state };
        return adapter.setAll(action.items, newState);

    case PersonaActionTypes.PERSONA_ACTION_FAIL:
        return { ...state };

    case PersonaActionTypes.GET_PERSONA:
        return { ...state };

    case PersonaActionTypes.INIT_PERSONA_SUCCESS:
        return { ...state, selectedPersona: action.persona };

    case PersonaActionTypes.SET_PERSONA:
        return { ...state, selectedPersona: action.persona };

    case PersonaActionTypes.SET_SKIP_SELECTION:
        return { ...state, skipSelection: action.value };

    default: {
        return state;
    }
    }
}

export const getSelectedPersona = (state: State) => state.selectedPersona;
export const getSkipSelection = (state: State) => state.skipSelection;
export const getEveryonePersonaId = (state: State) => {
    const personas = getAllPersonas(state);
    const everyonePersona = personas.find(item => item.name.toLowerCase() === 'everyone');
    if (!!everyonePersona) {
        return everyonePersona.organisationGroupId;
    }
    return null;
};
export const {
    selectIds: getPersonasIds,
    selectEntities: getPersonasEntities,
    selectAll: getAllPersonas,
    selectTotal: getTotalPersonas,
} = adapter.getSelectors();

export const personaSelectionViewedKey = 'PersonaSelectionViewed';
